import React, { useState } from "react"
import "./Sumary.css"
import requests from "../api/requests"
import { useNavigate } from "react-router-dom"
import { logout } from "../app/features/userSlice"
import { errorSnackBar } from "../components/snackBarOptions"
import { useSnackbar } from "react-simple-snackbar"
import { useDispatch } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSun, faWallet, faLock, faRightFromBracket } from "@fortawesome/free-solid-svg-icons"

function Sumary({ sections = [], scrollFunc, toggleDrawer }) {
  const [isLoadingPortal, setIsLoadingPortal] = useState(false)
  const [openErrorSnackbar] = useSnackbar(errorSnackBar)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const loadPortal = async () => {
    setIsLoadingPortal(true)
    let resp = null
    try {
      resp = await requests.createPortalSession({
        returnURL: window.location.origin,
      })
    } catch (error) {
      openErrorSnackbar("Ocorreu um erro inesperado")
      setIsLoadingPortal(false)
    }

    if (resp?.data?.url) {
      window.location.href = resp.data.url
    } else {
      setIsLoadingPortal(false)
    }
  }

  const handleLogout = async () => {
    try {
      await requests.logout()
      dispatch(logout())
    } catch (error) {
      openErrorSnackbar("Ocorreu um erro inesperado")
    }
  }

  return (
    <div className="sumary">
      <div className="sumary__header">
        <img className="sumary__logo" src="Primário_5.svg" alt="Cosmo" />
      </div>

      <div className="sumary__body">
        <ul>
          {sections.map((section, i) =>
            section?.contents?.length > 0 ? (
              <li key={i}>
                <button
                  className="sumary__item"
                  onClick={() => {
                    scrollFunc(i)
                    toggleDrawer(false)()
                  }}
                >
                  {section?.title}
                </button>
              </li>
            ) : null,
          )}
        </ul>
      </div>

      <div className="sumary__footer">
        <ul>
          <li>
            <button className="sumary__item" onClick={loadPortal}>
              {isLoadingPortal ? (
                <FontAwesomeIcon icon={faSun} spin />
              ) : (
                <FontAwesomeIcon icon={faWallet} />
              )}
              Gerenciar Assinatura
            </button>
          </li>
          <li>
            <button className="sumary__item" onClick={() => navigate("/profile")}>
              <FontAwesomeIcon icon={faLock} />
              Alterar Senha
            </button>
          </li>
        </ul>
        <button className="sumary__logout" onClick={handleLogout}>
          <FontAwesomeIcon icon={faRightFromBracket} />
          Sair da Conta
        </button>
      </div>
    </div>
  )
}

export default Sumary
